import { ColDef } from 'ag-grid-community'
import { AssetNameCell, ColDefWithLoading, LoadingTable, Table } from 'components/core-v2'
import { useParams } from 'react-router-dom'

import { useGetByTenantAccountAndAccountSourceAccountIdentifierQuery } from '@/api'
import { TENANT } from '@/const'

import classes from './portfolio-assets-overview.module.scss'

export const COLUMN_DEFS: ColDefWithLoading[] = [
  {
    headerName: 'Name',
    field: 'name',
    minWidth: 200,
    flex: 0.6,
    cellRenderer: AssetNameCell,
    cellStyle: { display: 'flex' },
    loadingCellWidth: 'md'
  },
  {
    headerName: 'Weight',
    field: 'weight',
    minWidth: 140,
    flex: 0.1,
    type: 'rightAligned'
  }
]

export const DEFAULT_COLUMN_OPTIONS: ColDef = {
  sortable: false,
  unSortIcon: true
}

export const Loading = () => (
  <LoadingTable
    agGridProps={{ columnDefs: COLUMN_DEFS }}
    className={classes.root}
    height="300px"
    rowCount={7}
  />
)

export const PortfolioAssetsOverview = () => {
  const { source, tradeId } = useParams()
  const { data, isLoading } = useGetByTenantAccountAndAccountSourceAccountIdentifierQuery({
    tenant: TENANT,
    accountIdentifier: tradeId,
    accountSource: source
  })

  if (isLoading) return <Loading />

  const rowData =
    data.account.portfolio?.targetWeights?.map(targetWeight => ({
      name: targetWeight.asset.name,
      weight: `${targetWeight.weight * 100}%`,
      assetId: targetWeight.asset.assetId
    })) || []

  return (
    <Table
      agGridProps={{
        columnDefs: COLUMN_DEFS,
        defaultColDef: DEFAULT_COLUMN_OPTIONS,
        rowData,
        rowHeight: 44
      }}
      className={classes.root}
      height="300px"
    />
  )
}
